module.exports = __webpack_public_path__ + "static/media/sweet_view_5.9c80e89a.jpg";